import { Checkbox, Form, Input, Select, Spin, Tabs, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { match as routerMatch } from 'react-router-dom';
import { Dispatch } from 'redux';
import { aggregatorsListAction } from '~Aggregators/actions';
import IAggregator from '~Api/Aggregator/IAggregator';
import { aggregatorsSelector } from '~Aggregators/selectors';
import IReferralPartner from '~Api/ReferralPartner/IReferralPartner';
import StateEnum from '~Api/ReferralPartner/StateEnum';
import TypeEnum from '~Api/ReferralPartner/TypeEnum';
import { IGlobalState } from '~reducer';
import {
    referralPartnerGetAction,
    referralPartnerValueSetAction,
} from '~ReferralPartners/actions';
import { referralPartnerSelector } from '~ReferralPartners/selectors';
import Layout from './Layout';
import { IDictionary } from '~utilities/IDictionary';

interface IMatch {
    uuid: string;
}

interface IProps {
    match: routerMatch<IMatch>;
}

interface IPropsSelector {
    aggregators: IDictionary<IAggregator>;
    referralPartner: IReferralPartner;
}

interface IPropsDispatch {
    aggregatorsList: () => void;
    referralPartnerGet: () => void;
    referralPartnerValueSet: (key: keyof IReferralPartner, value: boolean|number|string) => void;
}

type Props = IProps & IPropsSelector & IPropsDispatch;

class Edit extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.onChangeFirstName = this.onChangeFirstName.bind(this);
        this.onChangeLastName = this.onChangeLastName.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeStreetAddress = this.onChangeStreetAddress.bind(this);
        this.onChangeSuburb = this.onChangeSuburb.bind(this);
        this.onChangePostcode = this.onChangePostcode.bind(this);
        this.onChangeState = this.onChangeState.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.onChangeCompanyName = this.onChangeCompanyName.bind(this);
        this.onChangeAbn = this.onChangeAbn.bind(this);
        this.onChangeGroupName = this.onChangeGroupName.bind(this);
        this.onChangeAggregatorUuid = this.onChangeAggregatorUuid.bind(this);
        this.onChangeLinkedInUrl = this.onChangeLinkedInUrl.bind(this);

        this.onChangeAcl = this.onChangeAcl.bind(this);
        this.onChangeNccp = this.onChangeNccp.bind(this);
        this.onChangeBanned = this.onChangeBanned.bind(this);
        this.onChangeChargesFee = this.onChangeChargesFee.bind(this);
        this.onChangeConductsBusinessInPerson = this.onChangeConductsBusinessInPerson.bind(this);
        this.onChangeDisclosesBenefits = this.onChangeDisclosesBenefits.bind(this);
        this.onChangeRefersClient = this.onChangeRefersClient.bind(this);
        this.onChangeIncludesCustomerInfo = this.onChangeIncludesCustomerInfo.bind(this);
    }

    public componentDidMount(): void {
        const { aggregators, referralPartner } = this.props;

        if (!aggregators) {
            this.props.aggregatorsList();
        }

        if (!referralPartner) {
            this.props.referralPartnerGet();
        }
    }

    public render(): JSX.Element {
        const { aggregators, match, referralPartner } = this.props;

        if (!referralPartner) {
            return (
                <Layout uuid={match.params.uuid} section='edit'>
                    <Typography.Title level={2}>Edit</Typography.Title>
                    <Spin/>
                </Layout>
            );
        }

        return (
            <Layout uuid={match.params.uuid} section='edit'>
                <Typography.Title level={2}>Edit</Typography.Title>
                <Tabs defaultActiveKey='general'>
                    <Tabs.TabPane key='general' tab='General'>
                        <Form.Item label='First Name' className='first-name'>
                            <Input onChange={this.onChangeFirstName} value={referralPartner.firstName} />
                        </Form.Item>
                        <Form.Item label='Last Name' className='last-name'>
                            <Input onChange={this.onChangeLastName} value={referralPartner.lastName} />
                        </Form.Item>
                        <Form.Item label='Phone' className='phone'>
                            <Input onChange={this.onChangePhone} value={referralPartner.phone} />
                        </Form.Item>
                        <Form.Item label='Email' className='email'>
                            <Input onChange={this.onChangeEmail} value={referralPartner.email} />
                        </Form.Item>
                        <Form.Item label='Street Address' className='street-address'>
                            <Input onChange={this.onChangeStreetAddress} value={referralPartner.streetAddress} />
                        </Form.Item>
                        <Form.Item label='Suburb' className='suburb'>
                            <Input onChange={this.onChangeSuburb} value={referralPartner.suburb} />
                        </Form.Item>
                        <Form.Item label='Postcode' className='postcode'>
                            <Input onChange={this.onChangePostcode} value={referralPartner.postcode} />
                        </Form.Item>
                        <Form.Item label='State' className='state'>
                            <Select onChange={this.onChangeState} value={referralPartner.state}>
                                <Select.Option value={StateEnum.AustralianCapitalTerritory}>ACT</Select.Option>
                                <Select.Option value={StateEnum.NewSouthWales}>NSW</Select.Option>
                                <Select.Option value={StateEnum.NorthernTerritory}>NT</Select.Option>
                                <Select.Option value={StateEnum.Queensland}>QLD</Select.Option>
                                <Select.Option value={StateEnum.SouthAustralia}>SA</Select.Option>
                                <Select.Option value={StateEnum.Tasmania}>TAS</Select.Option>
                                <Select.Option value={StateEnum.Victoria}>VIC</Select.Option>
                                <Select.Option value={StateEnum.WesternAustralia}>WA</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label='Type' className='type'>
                        <Select onChange={this.onChangeType} value={referralPartner.type}>
                                <Select.Option value={TypeEnum.Accountant}>Accountant</Select.Option>
                                <Select.Option value={TypeEnum.Leads}>Leads</Select.Option>
                                <Select.Option value={TypeEnum.Lender}>Lender</Select.Option>
                                <Select.Option value={TypeEnum.RealEstate}>Real Estate</Select.Option>
                                <Select.Option value={TypeEnum.Other}>Other</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item label='Company Name' className='company-name'>
                            <Input onChange={this.onChangeCompanyName} value={referralPartner.companyName} />
                        </Form.Item>
                        <Form.Item label='ABN/ACN' className='abn'>
                            <Input maxLength={11} onChange={this.onChangeAbn} value={referralPartner.abn} />
                        </Form.Item>
                        <Form.Item label='Group Name' className='group-name'>
                            <Input onChange={this.onChangeGroupName} value={referralPartner.groupName} />
                        </Form.Item>
                        <Form.Item label='Aggregator' className='aggregator'>
                            <Select onChange={this.onChangeAggregatorUuid} value={referralPartner.aggregatorUuid}>
                                <Select.Option value={null}>None</Select.Option>
                                {_.sortBy(aggregators, ['name']).map((aggregator: IAggregator) => <Select.Option key={aggregator.uuid} value={aggregator.uuid}>{aggregator.name}</Select.Option>)}
                            </Select>
                        </Form.Item>
                        <Form.Item label='LinkedIn' className='linked-in-url'>
                            <Input onChange={this.onChangeLinkedInUrl} value={referralPartner.linkedInUrl} />
                        </Form.Item>
                    </Tabs.TabPane>
                    <Tabs.TabPane key='questions' tab='Compliance Questions' className='questions'>
                        <Form.Item label='Holds ACL?' className='acl'>
                            <Checkbox onChange={this.onChangeAcl} checked={referralPartner.acl} />
                        </Form.Item>
                        <Form.Item label='Agrees to comply with NCCP?' className='nccp'>
                            <Checkbox onChange={this.onChangeNccp} checked={referralPartner.nccp} />
                        </Form.Item>
                        <Form.Item label='Has been banned?' className='banned'>
                            <Checkbox onChange={this.onChangeBanned} checked={referralPartner.banned} />
                        </Form.Item>
                        <Form.Item label='Charges the consumer a referral fee?' className='charges-fee'>
                            <Checkbox onChange={this.onChangeChargesFee} checked={referralPartner.chargesFee} />
                        </Form.Item>
                        <Form.Item label='Conducts business in person?' className='conducts-business-in-person'>
                            <Checkbox onChange={this.onChangeConductsBusinessInPerson} checked={referralPartner.conductsBusinessInPerson} />
                        </Form.Item>
                        <Form.Item label='Agrees to disclose benefits?' className='discloses-benefits'>
                            <Checkbox onChange={this.onChangeDisclosesBenefits} checked={referralPartner.disclosesBenefits} />
                        </Form.Item>
                        <Form.Item label='Agrees to refer the client to Funding?' className='refers-client'>
                            <Checkbox onChange={this.onChangeRefersClient} checked={referralPartner.refersClient} />
                        </Form.Item>
                        <Form.Item label='Agrees to provide customer details?' className='includes-customer-info'>
                            <Checkbox onChange={this.onChangeIncludesCustomerInfo} checked={referralPartner.includesCustomerInfo} />
                        </Form.Item>
                    </Tabs.TabPane>
                </Tabs>
            </Layout>
        );
    }

    private onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('firstName', event.target.value);
    }

    private onChangeLastName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('lastName', event.target.value);
    }

    private onChangePhone(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('phone', event.target.value);
    }

    private onChangeEmail(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('email', event.target.value);
    }

    private onChangeStreetAddress(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('streetAddress', event.target.value);
    }

    private onChangeSuburb(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('suburb', event.target.value);
    }

    private onChangePostcode(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('postcode', event.target.value);
    }

    private onChangeState(value: StateEnum): void {
        this.props.referralPartnerValueSet('state', value);
    }

    private onChangeType(value: TypeEnum): void {
        this.props.referralPartnerValueSet('type', value);
    }

    private onChangeCompanyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('companyName', event.target.value);
    }

    private onChangeAbn(event: React.ChangeEvent<HTMLInputElement>): void {
        if (/[^0-9]/.test(event.target.value)) {
            return;
        }

        this.props.referralPartnerValueSet('abn', event.target.value);
    }

    private onChangeGroupName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('groupName', event.target.value);
    }

    private onChangeAggregatorUuid(value: string): void {
        this.props.referralPartnerValueSet('aggregatorUuid', value);
    }

    private onChangeLinkedInUrl(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.referralPartnerValueSet('linkedInUrl', event.target.value);
    }

    private onChangeAcl(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('acl', event.target.checked);
    }

    private onChangeNccp(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('nccp', event.target.checked);
    }

    private onChangeBanned(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('banned', event.target.checked);
    }

    private onChangeChargesFee(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('chargesFee', event.target.checked);
    }

    private onChangeConductsBusinessInPerson(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('conductsBusinessInPerson', event.target.checked);
    }

    private onChangeDisclosesBenefits(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('disclosesBenefits', event.target.checked);
    }

    private onChangeRefersClient(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('refersClient', event.target.checked);
    }

    private onChangeIncludesCustomerInfo(event: CheckboxChangeEvent): void {
        this.props.referralPartnerValueSet('includesCustomerInfo', event.target.checked);
    }
}

function mapStateToProps(state: IGlobalState, ownProps: IProps): IPropsSelector {
    return {
        aggregators: aggregatorsSelector(state),
        referralPartner: referralPartnerSelector(state, ownProps.match.params.uuid),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        aggregatorsList: () => dispatch(aggregatorsListAction()),
        referralPartnerGet: () => dispatch(referralPartnerGetAction(ownProps.match.params.uuid)),
        referralPartnerValueSet: (key: keyof IReferralPartner, value: boolean|number|string) => dispatch(referralPartnerValueSetAction(ownProps.match.params.uuid, key, value)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Edit);
